import Grid from "@mui/material/Grid";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { PolicyWithCheckReceivalDataFragment } from "@covertree/agent-portal-graphql";

interface StripeCustomerIdProps {
  policy: PolicyWithCheckReceivalDataFragment;
}

export function StripeCustomerId({ policy }: StripeCustomerIdProps) {
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Stripe customer ID",
            value: policy.stripeCustomerId,
            gridSize: 12,
          },
        ]}
      />
    </Grid>
  );
}
